<template>
  <div class="board_contents">
    <div class="container">
      <div class="search_sort">
        <select
          v-model="selectedSort"
          class="niceSelect notice"
          @change="handleSortChange"
        >
          <!-- <select v-model="selectedSort" class="niceSelect notice"> -->
          <!-- <select class="notice" id="sortOptions" onchange="window.open('/notice?sort=' + value,'_self');"> -->
          <option value="0" selected>최신순</option>
          <option value="1">과거순</option>
          <option value="2">조회순</option>
        </select>
        <!-- <select class="niceSelect notice" id="sortOptions" onchange="window.open('/notice?sort=' + value,'_self');">
            <select class="notice" id="sortOptions" onchange="window.open('/notice?sort=' + value,'_self');">
              <option value="0" selected>최신순</option>
              <option value="1">과거순</option>
              <option value="2">조회순</option>
            </select> -->
      </div>
      <table class="bbs_table_1">
        <colgroup>
          <col width="100" />
          <col width="*" />
          <col width="180" />
          <col width="180" />
          <col width="180" />
        </colgroup>
        <thead>
          <th>No</th>
          <th>제목</th>
          <th>등록자</th>
          <th>작성일</th>
          <th>조회수</th>
        </thead>
        <tbody v-if="noticeData">
          <tr v-for="(item, index) in noticeData.content" :key="index">
            <td class="no">
              <!-- 1번부터 순서대로 나열 되어야함 -->
              {{
                noticeData.page_info.total_size -
                (noticeData.page_info.request_page - 1) *
                  noticeData.page_info.request_size -
                index
              }}
            </td>
            <td class="text_left">
              <a :href="'/notice/' + item.idx">{{ item.title }}</a>
              <!-- <a @click="getIdx(item.idx )">{{ item.title }}</a> -->
            </td>
            <td>관리자</td>
            <td>
              <!-- 시간 제외한 날짜만 출력 되어야 함  -->
              {{ item.created_at.split(' ')[0] }}
            </td>
            <td>
              {{ item.view }}
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="nonotu" colspan="6">공지사항이 없습니다.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="bbs_paging">
      <!-- <div class="container">
            <ul>
              <li><a @click="changePage(currentPage - 1)"><img src="/assets/images/icon/page-arrow-left.png" alt="" /></a></li>
              <li v-for="(page_data, index) in pageArray.total_pages" :key="index">
                <a class="num" :class="{'on' : page_data == pageArray.request_page}" @click="getData(page_data)">{{ page_data }}</a>
              </li>
              <li><a @click="changePage(currentPage + 1)"><img src="/assets/images/icon/page-arrow-right.png" alt="" /></a></li>
            </ul>
          </div> -->
      <div class="container">
        <ul>
          <li>
            <a>
              <!-- <img
                src="../../public/assets/images/icon/page-arrow-left.png"
                alt=""
              /> -->
              <img src="../assets/images/icon/page-arrow-left.png" alt="" />
            </a>
          </li>
          <li v-for="(page_data, index) in pageArray.total_pages" :key="index">
            <a
              class="num"
              :class="{ on: page_data == pageArray.request_page }"
              @click="getData(page_data)"
              >{{ page_data }}</a
            >
          </li>
          <li>
            <!-- <a>
              <img
                src="../../public/assets/images/icon/page-arrow-right.png"
                alt=""
              />
            </a> -->
            <a>
              <img src="../assets/images/icon/page-arrow-right.png" alt="" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, getCurrentInstance } from 'vue'
// import { useRoute, useRouter } from 'vue-router';
// import { useRoute, useRouter } from 'vue-router';
import { loadNotice } from '../api/boards'

export default {
  name: 'ShowNotice',
  setup() {
    const router = getCurrentInstance().proxy.$router
    // const route = useRoute();
    // const router = useRouter();

    const currentPage = ref()
    const totalPages = ref()

    const selectedSort = ref(0)
    const noticeData = ref([])
    const pageArray = ref([])
    const page = ref(0)
    // eslint-disable-next-line no-shadow
    const getData = async (page) => {
      try {
        const response = await loadNotice(page, selectedSort)
        if (response.status_code === 200) {
          noticeData.value = response
          pageArray.value = response.page_info
          totalPages.value = response.page_info.total_pages
          currentPage.value = response.page_info.request_page
        }
      } catch (error) {
        console.error('데이터로드 실패:', error)
      }
    }

    // 정렬 방식 변경 함수
    const handleSortChange = () => {
      currentPage.value = 1 // 정렬이 변경되면 첫 페이지로 이동
      getData(currentPage.value, selectedSort.value)
      router.push({
        path: '/notice',
        query: { page: 1, sort: selectedSort.value },
      })
    }

    // eslint-disable-next-line no-shadow
    const changePage = (page) => {
      // console.log(currentPage.value);
      // console.log(totalPages.value);
      if (page < 1 || page > totalPages.value) return
      currentPage.value = page
      router.push({
        path: '/notice',
        query: { page, sort: selectedSort.value },
      })
    }

    // const getIdx = async(noitceId) => {
    //   router.push(`/notice/${noitceId}`)
    // }
    onMounted(() => {
      getData()
    })
    return {
      noticeData,
      pageArray,
      page,
      getData,
      // getIdx,
      selectedSort,
      changePage,
      currentPage,
      totalPages,
      handleSortChange,
    }
  },
}
</script>
